// removed by extract-text-webpack-plugin
module.exports = {"ListHeader":"src-components----list-header-module---ListHeader---1CrUl","ListHeader__link":"src-components----list-header-module---ListHeader__link---2a4jQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/list-header.module.scss
// module id = 450
// module chunks = 35783957827783